import { Grid, Typography } from "@material-ui/core";
import moment from "moment/moment";
import { dateLabels } from "../../ContasReceberConstants";
import { useContasReceberService } from "../../context/ContasReceberContext";

export const ReportHeader = () => {
  const { cachedPeriod: period, filters } = useContasReceberService();

  return (
    <Grid item xs>
      <Typography variant="h4">Relatório de Contas a Receber</Typography>

      <Typography variant="subtitle2">
        Contas a receber {dateLabels[filters.dateFilter]} entre:{" "}
        {moment(period?.startDate, filters.period === "YYYY-MM-DD").format(
          "DD/MM/YYYY"
        )}{" "}
        e{" "}
        {moment(period?.endDate, filters.period === "YYYY-MM-DD").format(
          "DD/MM/YYYY"
        )}
      </Typography>
    </Grid>
  );
};
